/**
 * @fileoverview Default enum values used throughout the application.
 *
 * NOTE: Please don't import this file directly, but use the index file instead.
 */
import { MiaPlaza } from "@/Reinforced.Typings";

export const DefaultSubject = MiaPlaza.Model.Subject.Math;
export const DefaultMiniMeClosetCategory = MiaPlaza.LO.MiniMe.MiniMeClosetService.MiniMeClosetItemCategory.Face;
